import { MessageDescriptor } from '@lingui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isTranslatable = (obj: any): obj is string | MessageDescriptor =>
  obj && (typeof obj === 'string' || typeof obj.id === 'string');

export const isMessageDescriptor = (
  message: MessageDescriptor | string | undefined | null
): message is MessageDescriptor => {
  return typeof message !== 'string' && typeof message?.id === 'string';
};

export const toMessageDescriptor = (message: string | MessageDescriptor): MessageDescriptor =>
  isMessageDescriptor(message) ? message : { id: message };

export const toTranslationId = (
  message: string | MessageDescriptor | null | undefined
): string | undefined => {
  if (isMessageDescriptor(message)) {
    return message.id;
  }
  if (isTranslatable(message)) {
    return message;
  }
  return undefined;
};

/**
 * The intended usage of this function is inside unit tests or other places
 * where the string value does not matter (e.g.  as a `key` in React components).
 * In places where the value of the string does matter use `i18n._`
 * https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/737181906/Frontend+string+translation#Frontendstringtranslation-React:translatecomponentattributes:
 *
 */
export const messageDescriptorToString = (
  descriptor: MessageDescriptor | null | undefined
): string | undefined => descriptor?.id || undefined;
